import { type App } from 'vue'
import AppBadge from './app-badge.vue'
import AppButton from './app-button.vue'
import AppButtonBack from './app-button-back.vue'
import AppButtonFilter from './app-button-filter.vue'
import AppCard from './app-card.vue'
import AppCheckbox from './app-checkbox.vue'
import AppEmpty from './app-empty.vue'
import AppErrorMsg from './app-error-msg.vue'
import AppFilterBar from './app-filter-bar.vue'
import AppForm from './app-form.vue'
import AppFormSection from './app-form-section.vue'
import AppInput from './app-input.vue'
import AppInputNumber from './app-input-number.vue'
import AppInputPassword from './app-input-password.vue'
import AppLabelNew from './app-label-new.vue'
import AppNotice from './app-notice.vue'
import AppPagination from './app-pagination.vue'
import AppRouterView from './app-router-view.vue'
import AppSearch from './app-search.vue'
import AppSelect from './app-select.vue'
import AppSelectBranch from './app-select-branch.vue'
import AppSelectCurrency from './app-select-currency.vue'
import AppSelectSupplier from './app-select-supplier.vue'
import AppSubmit from './app-submit.vue'
import AppTabStatus from './app-tab-status.vue'
import AppTabStatusItem from './app-tab-status-item.vue'
import AppDatePicker from './datepicker/app-date-picker.vue'
import AppDateRangePicker from './datepicker/app-date-range-picker.vue'
import FaIcon from './fa-icon.vue'
import Modal from './modal'
import PageFilter from './page-filter'
import RainProductCode from './rain-product-code.vue'
import AppSubmenu from './submenu/app-submenu.vue'
import AppSubmenuItem from './submenu/app-submenu-item.vue'
import AppTable from './table/app-table.vue'
import AppTableCheckable from './table/app-table-checkable.vue'

export default {
  install (app: App) {
    app.component('AppBadge', AppBadge)
    app.component('AppButton', AppButton)
    app.component('AppButtonFilter', AppButtonFilter)
    app.component('AppButtonBack', AppButtonBack)
    app.component('AppCard', AppCard)
    app.component('AppCheckbox', AppCheckbox)
    app.component('AppDatePicker', AppDatePicker)
    app.component('AppDateRangePicker', AppDateRangePicker)
    app.component('AppEmpty', AppEmpty)
    app.component('AppErrorMsg', AppErrorMsg)
    app.component('AppFilterBar', AppFilterBar)
    app.component('AppForm', AppForm)
    app.component('AppFormSection', AppFormSection)
    app.component('AppInput', AppInput)
    app.component('AppInputNumber', AppInputNumber)
    app.component('AppInputPassword', AppInputPassword)
    app.component('AppLabelNew', AppLabelNew)
    app.component('AppNotice', AppNotice)
    app.component('AppPagination', AppPagination)
    app.component('AppRouterView', AppRouterView)
    app.component('AppSearch', AppSearch)
    app.component('AppSelect', AppSelect)
    app.component('AppSelectBranch', AppSelectBranch)
    app.component('AppSelectCurrency', AppSelectCurrency)
    app.component('AppSelectSupplier', AppSelectSupplier)
    app.component('AppSubmenu', AppSubmenu)
    app.component('AppSubmenuItem', AppSubmenuItem)
    app.component('AppSubmit', AppSubmit)
    app.component('AppTable', AppTable)
    app.component('AppTableCheckable', AppTableCheckable)
    app.component('AppTabStatus', AppTabStatus)
    app.component('AppTabStatusItem', AppTabStatusItem)
    app.component('FaIcon', FaIcon)
    app.component('RainProductCode', RainProductCode)
    app.use(Modal)
    app.use(PageFilter)
  },
}

declare module 'vue' {
  export interface GlobalComponents {
    AppBadge: typeof AppBadge,
    AppButton: typeof AppButton,
    AppButtonBack: typeof AppButtonBack,
    AppButtonFilter: typeof AppButtonFilter,
    AppCard: typeof AppCard,
    AppCheckbox: typeof AppCheckbox,
    AppDatePicker: typeof AppDatePicker,
    AppDateRangePicker: typeof AppDateRangePicker,
    AppEmpty: typeof AppEmpty,
    AppErrorMsg: typeof AppErrorMsg,
    AppFilterBar: typeof AppFilterBar,
    AppForm: typeof AppForm,
    AppFormSection: typeof AppFormSection,
    AppInput: typeof AppInput,
    AppInputNumber: typeof AppInputNumber,
    AppInputPassword: typeof AppInputPassword,
    AppLabelNew: typeof AppLabelNew,
    AppNotice: typeof AppNotice,
    AppPagination: typeof AppPagination,
    AppRouterView: typeof AppRouterView,
    AppSearch: typeof AppSearch,
    AppSelect: typeof AppSelect,
    AppSelectBranch: typeof AppSelectBranch,
    AppSelectCurrency: typeof AppSelectCurrency,
    AppSelectSupplier: typeof AppSelectSupplier,
    AppSubmenu: typeof AppSubmenu,
    AppSubmenuItem: typeof AppSubmenuItem,
    AppSubmit: typeof AppSubmit,
    AppTable: typeof AppTable,
    AppTableCheckable: typeof AppTableCheckable,
    AppTabStatus: typeof AppTabStatus,
    AppTabStatusItem: typeof AppTabStatusItem,
    FaIcon: typeof FaIcon,
    RainProductCode: typeof RainProductCode,
  }
}
